import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_ENCRYTION_KEY || 'LURSxq8N3w';

// Encrypt Data
export const encryptData = (data: any): string => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

// Decrypt Data
export const decryptData = (encryptedData: string): any => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
};